/* eslint-disable no-unused-vars */
import { Field, Form, Formik } from "formik";
import React from "react";

function Body({ domainBrand }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["FUNDED_TRANSACTION_-271091899"]
                : "Funded Transactions"}
            </h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                {dictionary
                  ? dictionary["WO_USE_THIS_FORM_TO_FUN_974091924"]
                  : `Use this form to fund your network of Agents/Correspondents float. Agents/Correspondents float will be Deducted when they receive money from customers while Agents/Correspondents float will be Credited on pay-out money. All commissions will be credited to Agents/Correspondents float account.`}
              </li>
            </ol>
          </div>
        </div>
        <div className="ms-auto pageheader-btn" />
        <div className="row row-sm"></div>
      </div>
    </div>
  );
}

export default Body;
